"use client";

import { useIsomorphicLayoutEffect } from "@ui/hooks/useIsomorphicLayoutEffect";

// This is a trick to get the width of the browser scrollbar by create a temporary element with forced scrollbars.
// Scrollbar width changes a lot from browser to browser and even OS to OS. On mobile it's usually 0 as it's layered over the content.
function getScrollbarWidth() {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);

    const inner = document.createElement("div");
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    document.body.removeChild(outer);

    return scrollbarWidth;
}

/**
 * Set the scrollbar width as a CSS variable.
 *
 * Usefull for hiding scrollbars without causing layout shifts.
 * Which fx can happen when using `overflow: hidden` on the body.
 */

export function SetScrollbarWidthVariable() {
    useIsomorphicLayoutEffect(() => {
        const scrollbarWidth = getScrollbarWidth();
        document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    }, []);

    return null;
}
